import { Article, Category } from 'constants/blog';
import { getAllCategories } from 'services/server/sanity/groq/getAllCategoriesFromPosts';
import { getAllPosts } from 'services/server/sanity/groq/getAllPosts';
import { fetchCategoriesFromJson } from 'utils/shared/categories/fetchCategoriesFromJson';
import BlogPage from 'screens/Blog';
import { PAGE_SIZE } from 'components/blog/PostsList/PostsList';

const HOUR = 3600;
const CACHE_TIME = HOUR / 2;
const FEATURE_POSTS_COUNT = 1;

// Helper to determine if running in staging environment
const isStaging = () => process.env.NEXT_PUBLIC_ENABLE_DRAFT_MODE === 'true';

export const getStaticProps = async () => {
  const categories = await getAllCategories();
  const { posts, totalCount } = await getAllPosts(PAGE_SIZE + FEATURE_POSTS_COUNT, 0, []);

  const props = {
    articles: posts || [],
    categories: fetchCategoriesFromJson(categories),
    articlesCount: totalCount,
  };

  return {
    props,
    // 1 second in staging for immediate draft updates, 30 minutes in production
    revalidate: isStaging() ? 1 : CACHE_TIME,
  };
};

const Blog: React.FC<{ articles: Article[]; categories: Category[]; articlesCount: number }> = ({
  articles,
  categories,
  articlesCount,
}) => <BlogPage categories={categories} articles={articles} articlesCount={articlesCount} />;

export default Blog;
